import type { SizeGuide, SizeGroup } from "@/types";

/**
 * Guias de medidas da Auréa.
 *
 * Para calçados usamos a numeração brasileira (34 a 40) e o comprimento do pé
 * em centímetros. Para acessórios como bolsas, cintos e semijoias, o tamanho é
 * único e o guia traz apenas orientações.
 */

export const shoeSizeGuide: SizeGuide = {
  title: "Guia de numeração",
  subtitle: "Confira a numeração brasileira e o comprimento do pé para acertar de primeira.",
  headers: ["Numeração BR", "Comprimento do pé", "Referência"],
  rows: [
    { size: "34", values: ["22,0 cm", "Pé fino"] },
    { size: "35", values: ["22,7 cm", "Pé fino / médio"] },
    { size: "36", values: ["23,4 cm", "Médio"] },
    { size: "37", values: ["24,1 cm", "Médio"] },
    { size: "38", values: ["24,8 cm", "Médio / largo"] },
    { size: "39", values: ["25,5 cm", "Largo"] },
    { size: "40", values: ["26,2 cm", "Largo"] },
  ],
  note:
    "Meça o pé descalço, do calcanhar até o dedo mais longo, apoiado em uma folha de papel. Se ficar entre dois números, escolha o maior. Em caso de dúvida, fale com a gente pelo atendimento.",
};

export const accessorySizeGuide: SizeGuide = {
  title: "Guia de medidas",
  subtitle: "Este produto tem tamanho único e se ajusta a diferentes medidas.",
  headers: ["Item", "Medida", "Observação"],
  rows: [
    { size: "Bolsa", values: ["Medidas indicadas na descrição", "Alça ajustável quando aplicável"] },
    { size: "Cinto", values: ["Cintura regulável", "Confirme a numeração no atendimento"] },
    { size: "Semijoias", values: ["Tamanho único", "Banho dourado suave"] },
  ],
  note:
    "As medidas são aproximadas e podem variar levemente conforme o modelo. Se precisar de ajuda para escolher, fale com a gente pelo WhatsApp.",
};

export const sizeGuideNote = shoeSizeGuide.note;

export const getSizeGuide = (group: SizeGroup): SizeGuide =>
  group === "accessory" ? accessorySizeGuide : shoeSizeGuide;